// Build info — helps visually verify which build is currently deployed.
// Bump BUILD_VERSION whenever a deployment is made; the timestamp is updated
// automatically at build-time by CRA (from the file's mtime).
export const BUILD_VERSION = 'v2026.02.01-01';
export const BUILD_LABEL = 'خصومات + طباعة صافي الرصيد';
